/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { LegacyDataSheetGrouping } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const legacyDataSheetArchive = (
    dataSheetId: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/DataSheet/Archive/${dataSheetId}`,
        undefined,
        options
    );
};

export const getLegacyDataSheetArchiveMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyDataSheetArchive>>,
        TError,
        { dataSheetId: string },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyDataSheetArchive>>,
    TError,
    { dataSheetId: string },
    TContext
> => {
    const mutationKey = ["legacyDataSheetArchive"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyDataSheetArchive>>,
        { dataSheetId: string }
    > = (props) => {
        const { dataSheetId } = props ?? {};

        return legacyDataSheetArchive(dataSheetId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyDataSheetArchiveMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyDataSheetArchive>>
>;

export type LegacyDataSheetArchiveMutationError = AxiosError<unknown>;

export const useLegacyDataSheetArchive = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyDataSheetArchive>>,
            TError,
            { dataSheetId: string },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyDataSheetArchive>>,
    TError,
    { dataSheetId: string },
    TContext
> => {
    return useMutation(
        getLegacyDataSheetArchiveMutationOptions(options),
        queryClient
    );
};
export const legacyDataSheetGroupings = (
    dataSheetId: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyDataSheetGrouping[]>> => {
    return axios.get(`/v1/DataSheet/Groupings/${dataSheetId}`, options);
};

export const getLegacyDataSheetGroupingsQueryKey = (dataSheetId: string) => {
    return [`/v1/DataSheet/Groupings/${dataSheetId}`] as const;
};

export const getLegacyDataSheetGroupingsQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyDataSheetGroupingsQueryKey(dataSheetId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyDataSheetGroupings>>
    > = ({ signal }) =>
        legacyDataSheetGroupings(dataSheetId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: dataSheetId !== null && dataSheetId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyDataSheetGroupingsQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyDataSheetGroupings>>
>;
export type LegacyDataSheetGroupingsQueryError = AxiosError<unknown>;

export function useLegacyDataSheetGroupings<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                    TError,
                    Awaited<ReturnType<typeof legacyDataSheetGroupings>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyDataSheetGroupings<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                    TError,
                    Awaited<ReturnType<typeof legacyDataSheetGroupings>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyDataSheetGroupings<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyDataSheetGroupings<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyDataSheetGroupingsQueryOptions(
        dataSheetId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyDataSheetGroupingsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyDataSheetGroupingsQueryKey(dataSheetId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyDataSheetGroupings>>
    > = ({ signal }) =>
        legacyDataSheetGroupings(dataSheetId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyDataSheetGroupingsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyDataSheetGroupings>>
>;
export type LegacyDataSheetGroupingsSuspenseQueryError = AxiosError<unknown>;

export function useLegacyDataSheetGroupingsSuspense<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyDataSheetGroupingsSuspense<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyDataSheetGroupingsSuspense<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyDataSheetGroupingsSuspense<
    TData = Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
    TError = AxiosError<unknown>,
>(
    dataSheetId: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyDataSheetGroupings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyDataSheetGroupingsSuspenseQueryOptions(
        dataSheetId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
